/**
 * Created by Balazs Foldesi on 2017. 11. 08.
 */
module.exports = [
	function () {
		return {
			require: '^ngModel',
			link: function ($scope, elm, attrs, ctrl) {
				ctrl.$validators.placeholder = function (modelValue) {
					if ($scope.options && $scope.options[0] === modelValue && elm[0].attributes['data-placeholder-check']) {
						return false;
					} else {
						return true;
					}
				};
			}
		};
	}
];
